export class CatalogAccessRequest {
    'action';
    'body';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "action",
            "baseName": "action",
            "type": "string",
            "format": ""
        },
        {
            "name": "body",
            "baseName": "body",
            "type": "any",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CatalogAccessRequest.attributeTypeMap;
    }
    constructor() {
    }
}
